const LOCATION_TYPES = ['country', 'province', 'city', 'city_area', 'neighbourhood', 'district', 'street'];

export { LOCATION_TYPES };
